export enum SystemEnum {
  SYSTEM_CODE = '47d44ee33c',
  SYSTEM_ID = 'supplypro-lm',
}
